import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormControl from '@material-ui/core/FormControl';
import { useQuery } from 'react-apollo-hooks';
import { LIST_STORES } from '../../common/graphql/ListStores';
import get from 'lodash/get';

const styles = () => ({
  root: {
    color: 'white',
    borderRadius: 20,
    textTransform: 'unset',
    paddingRight: 25,
    paddingLeft: 25
  }
});

const StoreSelector = props => {
  const { classes, value, onChange } = props;
  const { data } = useQuery(LIST_STORES.query, {
    fetchPolicy: 'network-only'
  });
  console.log('data LIST_STORES', data); //TRACE
  const [selected, setSelected] = React.useState(value);
  const stores = React.useMemo(() => {
    return get(data, 'listStores.items', []).sort((a, b) => {
      const storeA = a.name.toUpperCase();
      const storeB = b.name.toUpperCase();
      if (storeA < storeB) {
        return -1;
      } else if (storeA > storeB) {
        return 1;
      } else {
        return 0;
      }
    });
  }, [data]);

  const handleChange = React.useCallback(
    e => {
      setSelected(e.target.value);
      const selectedStore = stores.find(s => s.id === e.target.value);
      onChange && onChange(e.target.value, selectedStore);
    },
    [onChange, stores]
  );
  return (
    <FormControl
      data-testid="cmi-store-selector"
      fullWidth
      variant="outlined"
      className={classes.formControl}>
      {/* <InputLabel shrink htmlFor="age-native-label-placeholder">
        Store
      </InputLabel> */}
      <Select
        native
        labelWidth={0}
        value={selected}
        fullWidth
        variant="standard"
        onChange={handleChange}
        input={<OutlinedInput name="age" id="age-native-label-placeholder" />}>
        <option value="">All Stores</option>
        {stores.map(stores => {
          return (
            <option key={stores.id} value={stores.id}>
              {stores.name}
            </option>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default withStyles(styles)(StoreSelector);
